
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["bx-analyse_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M85.333 512h85.334a340.736 340.736 0 0199.712-241.621 337.493 337.493 0 01108.458-72.96 346.453 346.453 0 01261.547-1.75 106.155 106.155 0 00106.283 102.998c59.136 0 106.666-47.531 106.666-106.667S805.803 85.333 746.667 85.333c-29.398 0-55.979 11.776-75.222 30.934-103.722-41.515-222.848-40.875-325.76 2.517a423.595 423.595 0 00-135.68 91.264A423.253 423.253 0 00118.7 345.685 426.88 426.88 0 0085.333 512zm741.248 133.205c-17.109 40.619-41.685 77.142-72.96 108.416s-67.797 55.851-108.458 72.96a346.453 346.453 0 01-261.547 1.75 106.155 106.155 0 00-106.283-102.998c-59.136 0-106.666 47.531-106.666 106.667s47.53 106.667 106.666 106.667c29.398 0 55.979-11.776 75.222-30.934A425.173 425.173 0 00512 938.667a425.941 425.941 0 00393.259-260.352A426.325 426.325 0 00938.667 512h-85.334a341.035 341.035 0 01-26.752 133.205z"}}),_c('path',{attrs:{"d":"M512 318.379c-106.752 0-193.621 86.869-193.621 193.621S405.248 705.621 512 705.621 705.621 618.752 705.621 512 618.752 318.379 512 318.379zm0 301.909c-59.69 0-108.288-48.597-108.288-108.288S452.309 403.712 512 403.712 620.288 452.309 620.288 512 571.691 620.288 512 620.288z"}})])
          )
        }
      }
    